import {
  Storage
} from "./chunk-GYE2SV7H.js";

// src/Pim/PimLanguage/PimContentLanguage.ts
var PIM_CONTENT_LANGUAGE_KEY = "pim_content_language";
var getContentLanguage = () => {
  try {
    const v = Storage.getItem(PIM_CONTENT_LANGUAGE_KEY);
    return typeof v === "string" ? v : "*";
  } catch {
    return "";
  }
};
var setContentLanguageStorage = (code) => {
  try {
    Storage.setItem(PIM_CONTENT_LANGUAGE_KEY, code ?? "");
  } catch {
  }
};
var contentLanguageParam = () => {
  const lang = getContentLanguage();
  return lang ? { lang } : {};
};
var getUrlLanguage = () => {
  try {
    if (typeof window === "undefined")
      return "";
    return new URLSearchParams(window.location.search).get("lang") ?? "";
  } catch {
    return "";
  }
};
var contentLanguageDetailParam = () => {
  const lang = getUrlLanguage() || getContentLanguage();
  return lang ? { lang } : {};
};

export {
  PIM_CONTENT_LANGUAGE_KEY,
  getContentLanguage,
  setContentLanguageStorage,
  contentLanguageParam,
  getUrlLanguage,
  contentLanguageDetailParam
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
